import React from 'react';
import ArticleDetailPage from './ArticleDetailPage';
import { threatResearchPosts, getThreatResearchBySlug } from '../config/threatResearchPosts';

const ThreatResearchDetailPage = () => (
  <ArticleDetailPage
    posts={threatResearchPosts}
    getBySlug={getThreatResearchBySlug}
    basePath="/threat-research"
    listPath="/threat-research"
    listLabel="Threat Research"
  />
);

export default ThreatResearchDetailPage;
